module.exports = __webpack_public_path__ + "img/table-medical.01af62fa.svg";